export default {
    // for filter panel
    page: '当前页',
    more: '更多',
    to: '至',
    of: '总数',
    next: '下一页',
    last: '上一页',
    first: '首页',
    previous: '上一页',
    loadingOoo: '加载中...',
    // for set filter
    selectAll: '全选',
    searchOoo: '请输入关键字...',
    blanks: '空白',
    // for number filter and text filter
    filterOoo: '过滤...',
    applyFilter: '应用过滤器...',
    // for number filter
    equals: '相等',
    notEqual: '不相等',
    lessThan: '小于',
    greaterThan: '大于',
    lessThanOrEqual: '小于等于',
    greaterThanOrEqual: '大于等于',
    inRange: '范围',
    contains: '包含',
    notContains: '不包含',
    startsWith: '开始于',
    endsWith: '结束于',
    // the header of the default group column
    group: '组',
    // tool panel
    columns: '列选项',
    rowGroupColumns: 'laPivot Cols',
    rowGroupColumnsEmptyMessage: '拖拽组到这里',
    valueColumns: 'laValue Cols',
    pivotMode: '枢轴模式',
    groups: 'laGroups',
    values: 'laValues',
    pivots: 'laPivots',
    valueColumnsEmptyMessage: 'la drag cols to aggregate',
    pivotColumnsEmptyMessage: 'la drag here to pivot',
    // other
    noRowsToShow: '无数据',
    // enterprise menu
    pinColumn: '固定列',
    valueAggregation: 'laValue Agg',
    autosizeThiscolumn: '自动调整当前网格宽度',
    autosizeAllColumns: '自动调整当前页所有网格宽度',
    groupBy: '排序',
    ungroupBy: '不排序',
    resetColumns: '恢复网格样式',
    expandAll: '展开全部',
    collapseAll: '关闭',
    toolPanel: '显示/隐藏控制表盘',
    export: '导出到...',
    csvExport: '导出CSV',
    excelExport: '导出Excel',
    // enterprise menu pinning
    pinLeft: '<<锁定至表格左侧',
    pinRight: '>>锁定至表格右侧',
    noPin: '<>取消锁定',
    // enterprise menu aggregation and status panel
    sum: '总数',
    min: '最小值',
    max: '最大值',
    none: '无',
    count: '总',
    average: '平均',
    // standard menu
    copy: '复制',
    copyWithHeaders: '复制内容及标题',
    ctrlC: 'ctrl + C',
    paste: '粘贴',
    ctrlV: 'ctrl + V',
    cut: '剪贴',
    cutV: 'ctrl + X',
    // status bar
    totalRows: '总行数',
    noMatches: '无匹配',
};
